<template>
  <div>
    <!--General Top Bar -->
    <!-- <general-top-bar :title="$t('settingsPages.tableManager')"></general-top-bar> -->
    <!--End General Top Bar -->
    <div class="settings-top-bar " ref="optionsTopBar" >
      <div class="text-right">
        <p class="">
          <button class="btn add"  @click.prevent="goToAdd" :title="$t('general.add') + ' ' + $t('settingUsers.single')">
            <img src="/static/img/icons/add.png">
            {{$t('general.add')}}
          </button>
        </p>
      </div>
    </div>
    <!-- Filters Card -->
    <div class="card mar-to-15" style="margin-left: 10px; margin-right: 10px;">
      <div class="card-content">
        <div style="display: flex; gap: 10px; flex-wrap: wrap; align-items: flex-end;">
          <!-- ID Filter -->
          <div class="form-group" style="flex: 0 0 100px; margin: 0;">
            <label>ID</label>
            <el-input
              v-model="filterId"
              placeholder="ID"
              size="small"
              clearable
            />
          </div>

          <!-- Location Filter -->
          <div class="form-group" v-if="locations.length" style="flex: 0 0 180px; margin: 0;">
            <label>{{$t('orders.location')}}</label>
            <el-select
              v-model="filterLocation"
              :placeholder="$t('general.select')"
              size="small"
              multiple
              collapse-tags
              clearable
              style="width: 100%;">
              <el-option
                v-for="loc in locations"
                :key="loc.true_id"
                :label="loc.name"
                :value="loc.true_id">
              </el-option>
            </el-select>
          </div>

          <!-- Table Name Filter -->
          <div class="form-group" style="flex: 0 0 150px; margin: 0;">
            <label>{{$t('settingTable.number')}}</label>
            <el-input
              v-model="filterTableName"
              :placeholder="$t('settingTable.number')"
              size="small"
              clearable
            />
          </div>

          <!-- Type Filter -->
          <div class="form-group" style="flex: 0 0 150px; margin: 0;">
            <label>{{$t('settingTable.type')}}</label>
            <el-select
              v-model="filterType"
              :placeholder="$t('general.select')"
              size="small"
              clearable
              style="width: 100%;">
              <el-option
                v-for="t in tableTypes"
                :key="t"
                :label="t"
                :value="t">
              </el-option>
            </el-select>
          </div>

          <!-- Zone Filter -->
          <div class="form-group" style="flex: 0 0 150px; margin: 0;">
            <label>{{$t('settingTable.zone')}}</label>
            <el-select
              v-model="filterZone"
              :placeholder="$t('general.select')"
              size="small"
              clearable
              style="width: 100%;">
              <el-option
                v-for="z in zones"
                :key="z.id"
                :label="z.name"
                :value="z.name">
              </el-option>
            </el-select>
          </div>

          <!-- Maps Filter -->
          <div class="form-group" style="flex: 0 0 200px; margin: 0;">
            <label>{{$t('settingTable.maps')}}</label>
            <el-select
              v-model="filterMaps"
              :placeholder="$t('general.search')"
              size="small"
              multiple
              filterable
              collapse-tags
              clearable
              style="width: 100%;">
              <el-option
                v-for="m in maps"
                :key="m.id"
                :label="m.name || ('ID ' + m.id)"
                :value="m.id">
              </el-option>
            </el-select>
          </div>

          <!-- User Filter -->
          <div class="form-group" style="flex: 0 0 180px; margin: 0;">
            <label>{{$t('reports.operator')}}</label>
            <el-select
              v-model="filterUser"
              ref="userSelect"
              value-key="id"
              multiple
              filterable
              remote
              collapse-tags
              reserve-keyword
              clearable
              :placeholder="$t('general.search')"
              :remote-method="searchUsers"
              :loading="loadingUsers"
              size="small"
              style="width: 100%;"
              @change="clearUserSearch">
              <el-option
                v-for="user in mergedUsers"
                :key="user.id"
                :label="user.firstname + ' ' + user.lastname"
                :value="user">
              </el-option>
            </el-select>
          </div>

          <!-- Search Button -->
          <div class="form-group" style="flex: 0 0 100px; margin: 0;">
            <button class="btn add" @click="applyFilters" :title="$t('reports.search')" style="width: 100%; font-size: 12px; padding: 4px 8px;">
              <i class="ti-search"></i> {{$t('general.search')}}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div style="display: flex;">
      <div class="card mar-to-15" style="width: calc(70% - 20px); margin-left: 10px; margin-right: 10px;">
        <div class="card-content">
          <data-tables
                v-loading="loading"
                :data="tableData"
                ref="userList"
                :search-def="{}"
                :pagination-def="{}"
                :table-props="{'border': false}"
                @row-click="goToRecord"
                style="width: 100%">
            <el-table-column
                            prop="id"
                            label="ID"
                            min-width="80"
                            sortable>
            </el-table-column>
            <el-table-column
                            prop="location_id"
                            :label="$t('orders.location')"
                            min-width="250"
                            sortable>
              <template slot-scope="scope">
                {{getLocationName(scope.row.location_id)}}
              </template>
            </el-table-column>
            <el-table-column v-for="column in tableColumns"
                            :key="column.label"
                            :min-width="column.minWidth"
                            :prop="column.prop"
                            :label="column.label"
                            sortable>
            </el-table-column>
            <el-table-column
                            :label="$t('settingTable.type')"
                            min-width="120">
              <template slot-scope="scope">
                <div v-if="scope.row.type === 'Kiosk' ? scope.row.kiosk_offline : scope.row.qr_offline"
                     class="cell-center" style="color: green;">Offline</div>
                <div v-else class="cell-center" style="color: red;">Online</div>
              </template>
            </el-table-column>
            <el-table-column
                  :width="160">
              <template>
                <div class="edit">
                  <i class="fa fa-pencil"></i>{{$t('general.edit')}}
                </div>
              </template>
            </el-table-column>
          </data-tables>
        </div>
      </div>
      <div class="card mar-to-15" style="width: calc(30% - 20px); margin-left: 10px; margin-right: 10px;">
        <div class="card-content" style="height:100%; width:100%; margin: 0;">
          <div class="middle" style="height:100%; width:100%;text-align: center;">
            <div :class="(loading2 ? 'show-loader' : 'hide-loader')">
              <div class="el-loading-spinner">
                <svg viewBox="25 25 50 50" class="circular">
                  <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
                </svg><!---->
              </div>
            </div>
            <!-- Kiosk view: reload controls instead of QR codes -->
            <div v-if="isKioskView" class="kiosk_reload_wrapper" style="width:100%;">
              <button class="btn btn-info mar-bt-20"
                      style="width:100%;"
                      :disabled="reloadingAll || allKiosksReloading"
                      @click="reloadAllKiosks">
                {{$t('settingTable.reloadAllKiosks')}}
              </button>
              <div v-for="kiosk in tableData"
                   :key="kiosk.id"
                   class="kiosk_reload_row"
                   style="display:flex; align-items:center; justify-content:space-between; gap:10px; padding:6px 0; border-bottom:1px solid #eee;">
                <span>{{kiosk.type}} {{kiosk.number}}</span>
                <button class="btn btn-simple btn-info"
                        :disabled="Number(kiosk.reload) === 1"
                        @click="reloadKiosk(kiosk)">
                  {{Number(kiosk.reload) === 1 ? $t('settingTable.reloadPending') : $t('settingTable.reload')}}
                </button>
              </div>
              <p class="mar-to-15" style="font-style:italic;">{{$t('settingTable.kiosksWillReloadNextOrder')}}</p>
            </div>
            <!-- QR view: keep the QR codes -->
            <template v-else>
            <template v-for="location in locationDataForTableManagement">
              <div :key="location.id || location.true_id || location.name" class="location_wrapper" v-if="location && location.table_management">
                <p style="margin: 0">{{location.name}}</p>
                <span style="display: none;">{{location.token}}</span>
                <img :src="location.table_management.qr_code" class="mar-to-15" alt="qrCode" :data-link="location.table_management.qr_link" @click="copyToClipboard(location.table_management.qr_link)">
                <a class="btn btn-info btn-icon duplicate-prod mar-to-15 mar-bt-20"
                :href="apiUrl + '/settings/download?token=' + token + '&url=' + location.table_management.qr_code + '&name=' + location.table_management.type + ' ' + location.table_management.number + '.png'"
                target="_blank">{{$t('upload.download')}}</a>
                <input class="copy_link mar-bt-20" type="text" @click="copyToClipboard(location.table_management.qr_link)" disabled=true :value="location.table_management.qr_link">
              </div>
            </template>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {Input, Table, TableColumn, Option, Pagination} from 'element-ui'
  import DataTables from 'vue-data-tables'
  // import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
  import PPagination from 'src/components/UIComponents/Pagination.vue'
  // import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'
  Vue.use(Input)
  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Option)
  Vue.use(Pagination)
  Vue.use(DataTables)
  export default {
    components: {
      PPagination,
      // GeneralTopBar,
      [Input.name]: Input
    },
    computed: {
      mergedUsers () {
        const map = new Map(this.users.map(item => [item.id, item]))
        this.selectedUsers.forEach(item => {
          if (!map.has(item.id)) {
            map.set(item.id, item)
          }
        })
        return Array.from(map.values())
      },
      isKioskView () {
        return window.location.href.toLowerCase().includes('kiosk')
      },
      allKiosksReloading () {
        return this.tableData.length > 0 && this.tableData.every(k => Number(k.reload) === 1)
      }
    },
    props: {
      callback: {
        required: false
      },
      callbackAdd: {
        required: false
      },
      isTable: {
        type: Boolean,
        default: false
      }
    },
    created () {
      this.initData()

      this.setTableTypes()
      this.$bus.$on('refresh', this.handleRefresh)
    },
    watch: {
      filterLocation () {
        // refresh map options when location filter changes
        this.getMaps()
      }
    },
    // mounted () {
    //   this.$bus.$on('refresh', this.handleRefresh)
    // },
    beforeDestroy () {
      this.$bus.$off('refresh', this.handleRefresh)
    },
    data () {
      return {
        loading: true,
        loading2: true,
        reloadingAll: false,
        token: null,
        apiUrl: null,
        filterId: '',
        filterLocation: [],
        filterTableName: '',
        filterType: '',
        filterZone: '',
        filterMaps: [],
        filterUser: [],
        users: [],
        selectedUsers: [],
        loadingUsers: false,
        tableTypes: ['Masa', 'Umbrela', 'Camera', 'Kiosk'],
        zones: [],
        maps: [],
        tableColumns: [
          {
            prop: 'number',
            label: this.$t('settingTable.number'),
            minWidth: 140
          },
          {
            prop: 'type',
            label: this.$t('settingTable.type'),
            minWidth: 150
          },
          {
            prop: 'zone',
            label: this.$t('settingTable.zone'),
            minWidth: 150
          }
        ],
        locationDataForTableManagement: [],
        tableData: [],
        locations: []
      }
    },
    methods: {
      handleRefresh () {
        this.initData()
      },
      initData () {
        this.apiUrl = process.env.API_BASE_URL
        this.token = this.$session.get('token')
        // Get locations from session
        this.locations = this.$session.get('selectedCompanyData').locations_details || []
        this.getData()
        if (this.isKioskView) {
          this.loading2 = false
        } else {
          this.getQrForLocations()
        }
        this.getZones()
        this.getMaps()
      },
      setTableTypes () {
        const url = window.location.href.toLowerCase()

        if (url.includes('kiosk')) {
          this.tableTypes = ['Kiosk']
          this.filterType = 'Kiosk'
          return
        }

        if (url.includes('qr')) {
          this.tableTypes = ['Masa', 'Umbrela', 'Camera']

          // fallback dacă era Kiosk selectat anterior
          if (!this.tableTypes.includes(this.filterType)) {
            this.filterType = ''
          }

          return
        }

        this.tableTypes = ['Masa', 'Umbrela', 'Camera', 'Kiosk']
      },
      getLocationName (locationId) {
        if (!locationId) return ''
        // First try to find in locationDataForTableManagement
        const location = this.locationDataForTableManagement.find(loc => loc.id === locationId || loc.true_id === locationId)
        if (location) {
          return location.name
        }
        // Fallback to locations from session
        if (this.locations && this.locations.length) {
          const sessionLocation = this.locations.find(loc => loc.id === locationId || loc.true_id === locationId)
          if (sessionLocation) {
            return sessionLocation.name
          }
        }
        return locationId
      },
      goToRecord (row, event, column) {
        if (typeof this.callback === 'function') {
          this.callback(row.id)
        } else {
          this.globalGoToRecord(row, event, column, '/user/edit/')
        }
      },
      getData () {
        const url = window.location.href.toLowerCase()

        if (url.includes('kiosk')) {
          this.filterType = 'Kiosk'
        }

        if (url.includes('qr')) {
          this.filterType = 'Masa'
        }

        var data = {
          token: this.token,
          company_id: this.$session.get('selectedCompany')
        }

        // Add filters if they have values
        if (this.filterId) data.id = this.filterId
        if (Array.isArray(this.filterLocation) && this.filterLocation.length) {
          data.location_ids = this.filterLocation
        }
        if (this.filterTableName) data.search = this.filterTableName
        if (this.filterType) data.type = this.filterType
        if (this.filterZone) data.zone = this.filterZone
        if (Array.isArray(this.filterMaps) && this.filterMaps.length) {
          data.map_ids = this.filterMaps
        }
        if (Array.isArray(this.filterUser) && this.filterUser.length) {
          data.user = this.filterUser.map(u => u.id)
        }

        this.apiRequest('/table-management', 'GET', data, (response) => {
          if (response.status === true) {
            // Convert object to array if needed
            this.tableData = Array.isArray(response.data)
              ? response.data
              : Object.values(response.data || {})

            this.$nextTick(() => {
              this.loading = false
            })
          } else {
            this.tableData = []
            this.$nextTick(() => {
              this.loading = false
            })
          }
        })
      },
      getQrForLocations () {
        var data = {
          token: this.token,
          company_id: this.$session.get('selectedCompany')
        }
        this.apiRequest('/table/get-qr-for-locations', 'GET', data, (response) => {
          if (response.status === true) {
            this.locationDataForTableManagement = response.data.locations

            this.$nextTick(() => {
              this.loading2 = false
            })
          }
        })
      },
      reloadAllKiosks () {
        this.reloadingAll = true
        const data = {
          token: this.token,
          company_id: this.$session.get('selectedCompany')
        }
        this.apiRequest('/table/reload-kiosks', 'POST', data, (response) => {
          if (response.status === true) {
            this.getData()
          }
          this.$nextTick(() => {
            this.reloadingAll = false
          })
        })
      },
      reloadKiosk (kiosk) {
        const data = {
          token: this.token,
          company_id: this.$session.get('selectedCompany'),
          table_id: kiosk.id
        }
        this.apiRequest('/table/reload-kiosks', 'POST', data, (response) => {
          if (response.status === true) {
            this.$set(kiosk, 'reload', 1)
          }
        })
      },
      copyToClipboard (textToCopy) {
        textToCopy = textToCopy.replace(/\s/g, '')
        this.$copyText(textToCopy).then(function (e) {
          // alert('Copied')
          // console.log(e)
        }, function (e) {
          // console.log('Can not copy')
          // console.log(e)
        })
      },
      goToAdd () {
        if (typeof this.callback === 'function') {
          this.callback(null)
        }
      },
      applyFilters () {
        this.selectedUsers = Array.isArray(this.filterUser) ? [...this.filterUser] : []
        this.loading = true
        this.getData()
      },
      searchUsers (query) {
        if (!query) {
          this.users = []
          return
        }

        const data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          search: query
        }

        this.loadingUsers = true
        this.apiRequest('/pos/all/users', 'GET', data, (response) => {
          if (response.status) {
            this.users = response.data.pos_user || []
          }
          this.$nextTick(() => {
            this.loadingUsers = false
          })
        })
      },
      clearUserSearch () {
        if (this.$refs.userSelect) {
          this.$refs.userSelect.focus()
          this.$refs.userSelect.query = ''
          this.$refs.userSelect.handleQueryChange('')
        }
      },
      getZones () {
        const data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }
        this.apiRequest('/table-zone', 'GET', data, (response) => {
          if (response.status === true && response.data.length) {
            this.zones = response.data.map(zone => ({
              id: zone.id,
              name: zone.name
            }))
          }
        })
      },
      getMaps () {
        const data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }
        if (Array.isArray(this.filterLocation) && this.filterLocation.length) {
          data.location_ids = this.filterLocation
        }
        this.apiRequest('/pos/all/map', 'GET', data, (response) => {
          if (response && response.status === true) {
            this.maps = response.data.table_maps || []
          } else {
            this.maps = []
          }
        })
      }
    }
  }
</script>
<style>
  .copy_link {
    width: 100%;
  }
  .middle {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Settings/TableManagement/TableManagement.vue